import { Tenancy_Rich_Asset_Type_Enum_Ps_Enum } from '@pypestream/api-services';

import * as RichAssetTypes from '.';

export class RichAssets {
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Buttons]: RichAssetTypes.RichAssetButtons =
    {
      type: 'static',
      options: [
        {
          dest: 100,
          label: 'Button with icon that opens URL when clicked',
          icon_prefix: '<<fas fa-home>>',
          icon_suffix: '',
          url: 'http://www.example.com',
          vars: [
            {
              variable: 'EXAMPLE_VARIABLE_1',
              value: 'example value 1',
            },
            {
              variable: 'EXAMPLE_VARIABLE_2',
              value: 'example value 2',
            },
          ],
        },
        {
          dest: 101,
          label: 'Button with icon at the end',
          icon_prefix: '',
          icon_suffix: '<<fas fa-home>>',
          vars: [
            {
              variable: 'CLICKED_BUTTON',
              value: 'true',
            },
          ],
        },
      ],
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Listpicker]: RichAssetTypes.RichAssetListpicker =
    {
      type: 'static',
      options: [
        {
          label: 'I want to submit a claim',
          dest: '23',
          image: 'https://www.insurance.com/claims.png',
          alt_text: 'A dancing penguin',
          description:
            'Submitting a claim will help get you in contact with an agent to get you the money you need.',
        },
      ],
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Imagebutton]: RichAssetTypes.RichAssetImagebutton =
    {
      type: 'static',
      options: [
        {
          label: 'label',
          dest: 'node_destination',
          image: 'URL',
          alt_text: 'alt_text',
          description: 'Description',
        },
        {
          label: 'label',
          dest: 'node_destination',
          image: 'URL',
          alt_text: 'alt_text',
          description: 'Description',
        },
      ],
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Datepicker]: RichAssetTypes.RichAssetDatepicker =
    'Enter an arrival date';
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Secure]: RichAssetTypes.RichAssetSecure =
    'User input is shown as asterisks: "****"';
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Carousel]: RichAssetTypes.RichAssetCarousel[] =
    [
      {
        title: 'First card title',
        image: 'https://www.example.com/image.jpg',
        subtitle: 'Subtitle',
        opt_text: 'Optional',
        label: 'Learn more',
        dest: '2',
        url: 'https://www.example.com',
        additional_cta: [
          {
            label: 'Second button',
            dest: '3',
          },
          {
            label: 'Third button',
            dest: '4',
          },
        ],
      },
      {
        title: 'Second card Title',
        image: 'https://www.example.com/image2.jpg',
        subtitle: 'Subtitle',
        opt_text: 'Optional',
        label: 'Learn more',
        dest: '100',
        additional_cta: [
          {
            label: 'Second button',
            dest: '5',
            url: 'https://www.google.com',
          },
          {
            label: 'Third button',
            dest: '6',
          },
        ],
      },
    ];
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Webview]: RichAssetTypes.RichAssetWebview =
    {
      type: 'static',
      url: 'https://www.qsgsoft.com/',
      label: 'View this exciting info.',
      close_message: 'Thanks for visiting',
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Document]: RichAssetTypes.RichAssetDocument =
    'https://www.example.com/';
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Image]: RichAssetTypes.RichAssetImage =
    {
      type: 'static',
      url: 'https://pypestream.com/pypebot.jpg',
      alt_text: 'A friendly helper',
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Video]: RichAssetTypes.RichAssetVideo =
    'https://www.example.com/';
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Location]: RichAssetTypes.RichAssetLocation =
    'Use the current location';
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.FileUpload]: RichAssetTypes.RichAssetFileUpload =
    {
      type: 'direct_post',
      endpoint: 'https://example.com/file/upload',
      upload_label: 'Upload label',
      cancel_label: 'Cancel label',
      headers: { key: 'value' },
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.PersistentMenu]: RichAssetTypes.RichAssetPersistentMenu =
    {
      type: 'static',
      options: [
        {
          label: 'Start Menu',
          dest: 1,
          set_value: 'start_over',
        },
        {
          label: 'Brand A',
          dest: 100,
          set_value: 'brandA',
        },
        {
          label: 'Brand B',
          dest: 200,
          set_value: 'brandB',
        },
      ],
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Star]: RichAssetTypes.RichAssetStar = {
    type: 'static',
    cta_label: 'Submit',
    options: [
      {
        dest: 20,
      },
      {
        dest: 21,
      },
      {
        dest: 22,
      },
      {
        dest: 23,
      },
      {
        dest: 24,
      },
    ],
  };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Png]: RichAssetTypes.RichAssetPng =
    'https://s3-us-west2.amazonaws.com/pypebots.pypestream.com/CX/RichAssetExamples/assets/office4.jpg';
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.QuickReply]: RichAssetTypes.RichAssetQuickReply =
    {
      type: 'static',
      options: [
        {
          label: 'Yes',
          dest: 11,
        },
        {
          label: 'No',
          dest: 12,
          url: 'http://www.example.com',
        },
      ],
    };
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Button]: RichAssetTypes.RichAssetButton =
    'Sights~2|Restaurants~43|Places to Stay~7';
  [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Audio]: RichAssetTypes.RichAssetAudio =
    {
      type: 'static',
      url: 'https://cdn.example.com/audio.mp3',
      loop: 2,
      alt_text: 'Please wait while we connect you',
    };

  createRichAssetTypeConfig = (): RichAssetTypes.RichAssetTypeConfig => {
    return {
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Buttons]: this.buttons,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Listpicker]: this.listpicker,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Imagebutton]: this.imagebutton,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Datepicker]: this.datepicker,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Secure]: this.secure,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Carousel]: this.carousel,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Webview]: this.webview,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Document]: this.document,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Image]: this.image,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Video]: this.video,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Location]: this.location,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.FileUpload]: this.file_upload,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.PersistentMenu]:
        this.persistent_menu,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Star]: this.star,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Png]: this.png,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.QuickReply]: this.quick_reply,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Button]: this.button,
      [Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Audio]: this.audio,
    };
  };
}
